import React, { createContext, useState, useContext }
    from 'react';
import { logoutUser } from '../services/userService';
import { logoutPoojari } from '../services/poojariService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(() => {
        try {
            const saved = localStorage.getItem('user');
            return saved ? JSON.parse(saved) : null;
        } catch {
            return null;
        }
    });

    const [token, setToken] = useState(
        localStorage.getItem('token') || null
    );

    // Login - dono token aur role save karo
    const login = (userData, jwtToken, refreshToken) => {
        setUser(userData);
        setToken(jwtToken);

        localStorage.setItem('user',
            JSON.stringify(userData));
        localStorage.setItem('token', jwtToken);
        localStorage.setItem('role',
            userData?.role || 'USER');

        if (refreshToken) {
            localStorage.setItem('refreshToken',
                refreshToken);
        }
    };

    // Profile update hone par user refresh karo
    const updateUserData = (userData) => {
        setUser(userData);
        localStorage.setItem('user',
            JSON.stringify(userData));
    };

    // Logout - backend ko bhi batao taaki token hat jaye
    const logout = async () => {
        const refreshToken =
            localStorage.getItem('refreshToken');
        const role = localStorage.getItem('role');

        try {
            if (role === 'POOJARI') {
                await logoutPoojari(refreshToken);
            } else {
                await logoutUser(refreshToken);
            }
        } catch (err) {
            // Backend call fail ho toh bhi local clear karo
            console.log('Logout call failed');
        }

        setUser(null);
        setToken(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('role');
    };

    return (
        <AuthContext.Provider value={{
            user,
            token,
            login,
            logout,
            updateUserData
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;